import { Suspense } from "react";
import { TenantResolver } from "../features/components"; 
import { useNavigate } from "react-router-dom"; 
import { useRecoilValue } from "recoil";
import { tenantState } from "../store/recoil/tenant/atoms";
import Loading from "../features/components/Loading";

const loading = () => <div />;

interface DefaultLayoutProps {

  children?: any;
  passtenantControl: boolean;
}

const DefaultLayout = (props: DefaultLayoutProps) => { 


  const { isfirmAvailable, isFetching,   } = useRecoilValue(tenantState);

  const navigate = useNavigate(); 
 

  if (isfirmAvailable == false && isFetching != true && window.location.href.indexOf("404") ==-1) {
  
    navigate("/404");
  }

  const children = props["children"] || null;

  return (
    <>
      <TenantResolver passtenantControl={props.passtenantControl} />
      {(isFetching && isfirmAvailable ) ? (
        <Loading />
      ) : (
        <Suspense fallback={loading()}>{children}</Suspense>
      )}

    </>
  );
};

export default DefaultLayout;
